module.exports = __webpack_public_path__ + "img/logo.dde73f97.png";